/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ answered: NonNullable<unknown>, total: NonNullable<unknown> }} Profile_Answered_OfInputs */

const en_us2_profile_answered_of = /** @type {(inputs: Profile_Answered_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.answered} of ${i?.total} answers`)
};

const pt_br2_profile_answered_of = /** @type {(inputs: Profile_Answered_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.answered} de ${i?.total} respostas`)
};

const es_419_profile_answered_of = /** @type {(inputs: Profile_Answered_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.answered} de ${i?.total} respuestas`)
};

const pt_pt2_profile_answered_of = /** @type {(inputs: Profile_Answered_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.answered} de ${i?.total} respostas`)
};

const fr_fr2_profile_answered_of = /** @type {(inputs: Profile_Answered_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.answered} réponses sur ${i?.total}`)
};

const de_de2_profile_answered_of = /** @type {(inputs: Profile_Answered_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.answered} von ${i?.total} Antworten`)
};

const it_it2_profile_answered_of = /** @type {(inputs: Profile_Answered_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.answered} di ${i?.total} risposte`)
};

/**
* | output |
* | --- |
* | "{answered} of {total} answers" |
*
* @param {Profile_Answered_OfInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_answered_of = /** @type {((inputs: Profile_Answered_OfInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Answered_OfInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_answered_of(inputs)
	if (locale === "es-419") return es_419_profile_answered_of(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_answered_of(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_answered_of(inputs)
	if (locale === "de-DE") return de_de2_profile_answered_of(inputs)
	if (locale === "it-IT") return it_it2_profile_answered_of(inputs)
	return en_us2_profile_answered_of(inputs)
});
export { profile_answered_of as "profile.answered_of" }